module.exports = __webpack_public_path__ + "img/school.429f198e.jpg";